package com.cybersoftsolution.cybersoftsolutionweb.pages.admin

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.cybersoftsolution.cybersoftsolutionweb.components.bars.SearchBarWithCategory
import com.cybersoftsolution.cybersoftsolutionweb.components.layouts.AdminPageLayout
import com.cybersoftsolution.cybersoftsolutionweb.components.layouts.IsAuthenticatedLayout
import com.cybersoftsolution.cybersoftsolutionweb.components.layouts.PageableLayout
import com.cybersoftsolution.cybersoftsolutionweb.components.posts.PostPreview
import com.cybersoftsolution.cybersoftsolutionweb.components.toast.MyToastAction
import com.cybersoftsolution.cybersoftsolutionweb.components.toast.MyToastContainer
import com.cybersoftsolution.cybersoftsolutionweb.components.toast.MyToastMessage
import com.cybersoftsolution.cybersoftsolutionweb.components.toast.showMyToast
import com.cybersoftsolution.cybersoftsolutionweb.models.Category
import com.cybersoftsolution.cybersoftsolutionweb.models.Post
import com.cybersoftsolution.cybersoftsolutionweb.models.SimplePost
import com.cybersoftsolution.cybersoftsolutionweb.models.ui.PostsUI
import com.cybersoftsolution.cybersoftsolutionweb.navigation.Screen
import com.cybersoftsolution.cybersoftsolutionweb.navigation.navigateTo
import com.cybersoftsolution.cybersoftsolutionweb.pages.admin.Device.isDesktop
import com.cybersoftsolution.cybersoftsolutionweb.styles.SearchBarStyle
import com.cybersoftsolution.cybersoftsolutionweb.use_cases.deletePostsUseCase
import com.cybersoftsolution.cybersoftsolutionweb.use_cases.getSimplePostsUseCase
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.searchTextFieldId
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.toastActionDeleteID
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.toastBasicID
import com.stevdza.san.kotlinbs.models.ToastStyle
import com.stevdza.san.kotlinbs.models.button.ButtonVariant
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px


@Composable
    fun PostsPage(){

    val context = rememberPageContext()
    var isLoading by remember { mutableStateOf(false) }
    var isSearching by remember { mutableStateOf(false) }
    var state by remember { mutableStateOf(PostsUI())}
    val scope = rememberCoroutineScope()
    var requestAfterDeleteIfPageIsEmpty by remember { mutableStateOf(false) }

    val modifierContent = Modifier
        .fillMaxWidth(if (isDesktop()) {70.percent} else {90.percent})
        .padding(leftRight = 24.px)
        .margin(topBottom = 24.px)


    LaunchedEffect(key1 = Unit, key2 = (requestAfterDeleteIfPageIsEmpty)){
        scope.launch {
            getSimplePostsUseCase(
                state = state,
                setSearching = { isSearching = it },
                setState = { state = it },
                text = state.searchText,
                category = state.searchCategory?.name,
                requestPage = state.page?.currentPage,
                limit = state.limit
            )
        }
        requestAfterDeleteIfPageIsEmpty = false
    }

    LaunchedEffect(state.selectPost){
        if (!state.selectPost) {
            val simplePosts = state.page?.list?.map { simplePost ->
                simplePost.copy(selected = false)
            }
            state = state.copy(
                page = simplePosts?.let {
                    state.page?.copy(
                        list = it
                    )
                }
            )
        }
    }

        AdminPageLayout(
            isLoading = isLoading,
        ){

            Column(
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.Top,
                modifier = Modifier
                    .fillMaxWidth(if (isDesktop()) {90.percent} else {95.percent})
                    .margin(topBottom = 24.px)
//                modifier = Modifier
//                    .fillMaxWidth(if (isDesktop()) {90.percent} else {95.percent})
//                    .borderRadius(25.px)
//                    .margin(topBottom = 24.px)
//                    .padding(topBottom = 25.px, leftRight = 8.px)
            ){
//                Text(getLocalDateTime().toStringDateTime())

                SearchBarWithCategory(
                    modifier = Modifier
                        .margin(bottom = 12.px),
                    enabled = !isSearching,
                    searchText = state.searchText,
                    id = searchTextFieldId,
                    onSearchTextChange = {
                        state = state.copy(searchText = it)
                    },
                    style = SearchBarStyle,
                    isSearching = isSearching,
                    setSearching = {
                        isSearching = it

                    },
                    categories = Category.entries.map { if (it==Category.NoCategory) {"Any"} else {it.name} },
                    onSearch = { text, category ->

                        state = state.copy(
                            searchText = text,
                            searchCategory = try { Category.valueOf(category?:"") } catch (e:Exception) {null}
                        )

                        scope.launch {

                            getSimplePostsUseCase(
                                state = state,
                                setSearching = { isSearching = it },
                                setState = { state = it },
                                text = state.searchText,
                                category = state.searchCategory?.name,
                                requestPage = 1,
                                limit = state.limit
                            )
                        }

                    },

                )

                PageableLayout(
                    canSelectElements = state.selectPost,
                    setSelectElements = {
                        state = state.copy(selectPost = it)
                    },
                    limitOfElements = state.limit,
                    setLimitOfElements = { limit ->
                        state = state.copy(limit = limit)
                            scope.launch {
                                getSimplePostsUseCase(
                                    state = state,
                                    setSearching = { isSearching = it },
                                    setState = { state = it },
                                    text = state.searchText,
                                    category = state.searchCategory?.name,
                                    requestPage = 1,
                                    limit = state.limit
                                )
                            }
//                        }

                    },
                    isSearching = isSearching,
                    page = state.page,
                    goToPage = { page ->
                        scope.launch {
                            getSimplePostsUseCase(
                                state = state,
                                setSearching = { isSearching = it },
                                setState = { state = it },
                                text = state.searchText,
                                category = state.searchCategory?.name,
                                requestPage = page,
                                limit = state.limit
                            )
                        }
                    },
                    showMore = { page ->
                        scope.launch {
                            getSimplePostsUseCase(
                                state = state,
                                setSearching = { isSearching = it },
                                setState = { newState ->
                                    val mutableList:MutableList<SimplePost> = state.page?.list?.toMutableList()?: mutableListOf()
                                    mutableList.addAll(newState.page?.list?: emptyList())

                                    state = state.copy(
                                        page = newState.page?.copy(
                                            list = mutableList.toList(),
                                        )
                                    )

                                    },
                                text = state.searchText,
                                category = state.searchCategory?.name,
                                requestPage = page,
                                limit = state.limit
                            )
                        }

                    },
                    onDeleteClick = {
                        scope.showMyToast(toastActionDeleteID)
                    },
                    onEditClick = {
                        context.navigateTo(Screen.AdminCreate, mutableMapOf(Pair(Post::id.name,state.page?.list?.first { it.selected }?.id)))
                    },
                ){ elements ->

                    SimpleGrid(
                        modifier = Modifier
                            .fillMaxWidth()
                            .margin(bottom = 12.px),
                        numColumns = numColumns(
                            base = 1,
                            sm = 1,
                            md = 3,
                            lg = 4
                        )
                    ){
                        elements.forEach { element ->
                            PostPreview(
                                simplePost = element,
                                selectable = state.selectPost,
                                setSelectPost = { selected ->
                                    val simplePosts = state.page?.list?.map { simplePost ->
                                        if (simplePost.id == element.id) {
                                            simplePost.copy(selected = selected)
                                        } else {
                                            simplePost
                                        }
                                    }
                                    state = state.copy(
                                        page = simplePosts?.let {
                                            state.page?.copy(
                                                list = it
                                            )
                                        }
                                    )
                                }
                            )
                        }

                    }

                }








            }



            MyToastContainer{
                MyToastMessage(
                    id = toastBasicID,
                    message = state.toastMessage.message,
                    style = state.toastMessage.style
                )

                MyToastAction(
                    id = toastActionDeleteID,
                    autoHide = true,
                    text = if ((state.page?.list?.count { it.selected } ?: 1) > 1)  "Seguro que desea eliminar estos ${state.page?.list?.count { it.selected }} elementos?" else "Seguro que desea eliminar este elemento?",
                    positiveButtonText = "Aceptar",
                    positiveButtonVariant = ButtonVariant.Primary,
                    negativeButtonVariant = ButtonVariant.Danger,
                    negativeButtonText = "Cancelar",
                    style = ToastStyle.Danger,
                    onPositiveButtonClick = {
                        scope.launch {
                            isLoading = true

                            val deletedSuccess = scope.deletePostsUseCase(
                                postIds = state.page?.list?.filter { it.selected }?.map { it.id.orEmpty() }?: emptyList(),
                                state = state,
                                setState = { state = it }
                            )

                            if (deletedSuccess) {
                                state = state.copy(
                                    page = state.page?.copy(
                                        list = state.page?.list?.filter { !it.selected }?: emptyList()
                                    )
                                )
                            }

                            isLoading = false

                            requestAfterDeleteIfPageIsEmpty = state.page?.list?.isEmpty() == true

                        }
                    },
                    onNegativeButtonClick = {}
                )




            }

        }

    }

    @Composable
    @Page(routeOverride = "posts")
    fun posts() {

    IsAuthenticatedLayout(delay = 0L, asAdmin = true) {
        PostsPage()
    }



    }

